module.exports = __webpack_public_path__ + "design-pen.ILLNPVYA.svg";